import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { string, object } from 'yup';
import { post } from '../../Services/http';

const formschema = object().shape({
    education: string().required(translate(`validation.required`)),
    client: string().required(translate(`validation.required`)),
    location: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.emailInvalid`)),
    phone: string()
        .required(translate(`validation.required`))
        .matches(/^\+?\d{10,15}$/, translate(`validation.invalid.number`)),
    orgNr: string()
        .required(translate(`validation.required`))
        .matches(/^(\d{6}-\d{4}|\d{10})$/, translate(`validation.invalid.number`)),
    invoiceId: string().required(translate(`validation.required`)),
    invoiceEmail: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.emailInvalid`)),
    numberOfParticipants: string().required(translate(`validation.required`)),
    participants: string().required(translate(`validation.required`)),
});

const DEFAULT_MAX_PARTICIPANTS = 10;

const formatEducation = (education) =>
    education.ArticleNumber
        ? `${education.Name} (${education.ArticleNumber})`
        : education.Name;

export const EducationBlock = ({ model }) => {
    const educations = model.Educations || [];
    const hasEducations = educations.length > 0;

    const initialValues = {
        education: '',
        articleNumber: '',
        client: '',
        location: '',
        email: '',
        phone: '',
        orgNr: '',
        invoiceId: '',
        invoiceEmail: '',
        numberOfParticipants: '',
        participants: '',
        recipientEmail: model.RecipientEmail,
    };

    const [form, setForm] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);

    const onChange = (propName, value) => {
        setForm((prevState) => ({
            ...prevState,
            [propName]: value,
        }));
    };

    const selectedEducationIndex = educations.findIndex(
        (education) =>
            education.Name === form.education &&
            (education.ArticleNumber || '') === form.articleNumber
    );

    const maxParticipants =
        selectedEducationIndex >= 0
            ? educations[selectedEducationIndex].MaxParticipants
            : DEFAULT_MAX_PARTICIPANTS;
    const participantOptions = Array.from(
        { length: maxParticipants },
        (_, i) => i + 1
    );

    const onEducationSelect = (index) => {
        const education = educations[index];
        const max = education
            ? education.MaxParticipants
            : DEFAULT_MAX_PARTICIPANTS;
        setForm((prevState) => ({
            ...prevState,
            education: education ? education.Name : '',
            articleNumber: education ? education.ArticleNumber || '' : '',
            numberOfParticipants:
                Number(prevState.numberOfParticipants) > max
                    ? ''
                    : prevState.numberOfParticipants,
        }));
    };

    const onSubmit = async () => {
        
        try {
            await formschema.validate(form, { abortEarly: false });
            setErrors({});
            const res = await post('/api/educationmail', {
                ...form,
                numberOfParticipants: Number(form.numberOfParticipants),
            });

            if (res.status < 300 && res.status > 199) {
                setMessage(translate('education.block.success'));
                setForm(initialValues);
            } else {
                setMessage(translate('education.block.failed'));
            }
        } catch (error) {
            const validationErrors = {};
            error.inner.forEach((e) => {
                validationErrors[e.path] = e.message;
            });
            setErrors(validationErrors);
        }
    };

    return (
        <div className="contactusblock-container-right-container-content">
            <form className="contactusblock-container-right-container-form" onSubmit={(e) => e.preventDefault()}>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input1">
                            {translate('education.block.education')} *
                            {errors.education && <span className="contactusblock-container-right-container-content-form-error-message">{errors.education}</span>}
                        </label>
                        {hasEducations ? (
                            <select
                                className={`contactusblock-container-right-container-content-form-input contactusblock-container-right-container-content-form-input--select ${errors.education ? 'input-error' : ''
                                    }`}
                                value={selectedEducationIndex >= 0 ? selectedEducationIndex : ''}
                                id="input1"
                                name="input1"
                                onChange={(event) => onEducationSelect(event.target.value)}
                            >
                                <option value="">{translate('education.block.selecteducation')}</option>
                                {educations.map((education, index) => (
                                    <option key={index} value={index}>
                                        {formatEducation(education)}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input
                                className={`contactusblock-container-right-container-content-form-input ${errors.education ? 'input-error' : ''
                                    }`}
                                type="text"
                                value={form.education}
                                id="input1"
                                name="input1"
                                onChange={(event) => onChange('education', event.target.value)}
                            />
                        )}
                    </div>

                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input2">
                            {translate('education.block.client')} *
                            {errors.client && <span className="contactusblock-container-right-container-content-form-error-message">{errors.client}</span>}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            value={form.client}
                            id="input2"
                            name="input2"
                            onChange={(event) => onChange('client', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input3">
                            {translate('education.block.location')} *
                            {errors.location && <span className="contactusblock-container-right-container-content-form-error-message">{errors.location}</span>}
                        </label>
                        <input
                            className={`contactusblock-container-right-container-content-form-input ${errors.location ? 'input-error' : ''
                                }`}
                            type="text"
                            value={form.location}
                            id="input3"
                            name="input3"
                            onChange={(event) => onChange('location', event.target.value)}
                        />
                    </div>
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input4">
                            {translate('education.block.email')} *
                            {errors.email && <span className="contactusblock-container-right-container-content-form-error-message">{errors.email}</span>}
                        </label>
                        <input
                            className={`contactusblock-container-right-container-content-form-input ${errors.email ? 'input-error' : ''
                                }`}
                            type="text"
                            value={form.email}
                            id="input4"
                            name="input4"
                            onChange={(event) => onChange('email', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input5">
                            {translate('education.block.phone')} *
                            {errors.phone && <span className="contactusblock-container-right-container-content-form-error-message">{errors.phone}</span>}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            id="input5"
                            name="input5"
                            value={form.phone}
                            onChange={(event) => onChange('phone', event.target.value)}
                        />
                    </div>
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input6">
                            {translate('education.block.orgnr')} *
                            {errors.orgNr && <span className="contactusblock-container-right-container-content-form-error-message">{errors.orgNr}</span>}
                        </label>
                        <input
                            className={`contactusblock-container-right-container-content-form-input ${errors.orgNr ? 'input-error' : ''
                                }`}
                            type="text"
                            value={form.orgNr}
                            id="input6"
                            name="input6"
                            onChange={(event) => onChange('orgNr', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input7">
                            {translate('education.block.invoiceid')} * 
                            {errors.invoiceId && <span className="contactusblock-container-right-container-content-form-error-message">{errors.invoiceId}</span>}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            id="input7"
                            name="input7"
                            value={form.invoiceId}
                            onChange={(event) => onChange('invoiceId', event.target.value)}
                        />
                    </div>
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input8">
                            {translate('education.block.invoiceemail')} * 
                            {errors.invoiceEmail && <span className="contactusblock-container-right-container-content-form-error-message">{errors.invoiceEmail}</span>}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            id="input8"
                            name="input8"
                            value={form.invoiceEmail}
                            onChange={(event) => onChange('invoiceEmail', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input10">
                            {translate('education.block.numberofparticipants')} *
                            {errors.numberOfParticipants && <span className="contactusblock-container-right-container-content-form-error-message">{errors.numberOfParticipants}</span>}
                        </label>
                        <select
                            className={`contactusblock-container-right-container-content-form-input contactusblock-container-right-container-content-form-input--select ${errors.numberOfParticipants ? 'input-error' : ''
                                }`}
                            value={form.numberOfParticipants}
                            id="input10"
                            name="input10"
                            onChange={(event) => onChange('numberOfParticipants', event.target.value)}
                        >
                            <option value="">{translate('education.block.selectnumberofparticipants')}</option>
                            {participantOptions.map((count) => (
                                <option key={count} value={count}>
                                    {count}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-form">
                    <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input9">
                        {translate('education.block.participants')} *
                        {errors.participants && <span className="contactusblock-container-right-container-content-form-error-message-editor">{errors.participants}</span>}
                    </label>
                    <textarea
                        className="contactusblock-container-right-container-content-form-input-big"
                        type="textarea"
                        rows="5"
                        value={form.participants}
                        id="input9"
                        name="input9"
                        onChange={(event) => onChange('participants', event.target.value)}
                    />
                </div>
                {
                    model.UnderFormText != null && (
                        <div className="contactusblock-container-right-container-content-description"

                            dangerouslySetInnerHTML={{
                                __html: model.UnderFormText,
                            }}>
                        </div>
                        )
                }
                <button className="contactusblock-container-right-container-content-form-button" type="submit" onClick={() => onSubmit()}>
                    <p> {model.ButtonText == null ? "" : model.ButtonText } </p>
                </button>

                {message && (             
                    <p>{message}</p>
                )}
            </form>
        </div>
    );
};